import type { ReportButtonLabels } from '../../report-button-content';

export const reportButton: ReportButtonLabels = {
  report: 'Denunciar aquesta pàgina',
  title: 'Informar d\'un problema amb aquesta pàgina',
  reasons: {
    'inaccurate-or-fabricated': 'Informació inexacta o inventada',
    'wrong-product': 'Els productes no corresponen a la pàgina',
    'sexually-explicit': 'Contingut sexualment explícit',
    'regulated-product': 'Producte amb recepta o regulat',
    'dangerous-product': 'Producte perillós',
    'ip-infringement': 'Vulnera els meus drets (marca/drets d\'autor)',
    other: 'Una altra cosa',
  },
  detail: 'Detalls (opcional)',
  submit: 'Enviar la denúncia',
  cancel: 'Cancel·lar',
  sent: 'Gràcies. Revisem les denúncies en un termini de 24 hores.',
  failed: 'No s\'ha pogut enviar la denúncia. Torneu-ho a provar.',
};
